import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CoreResponse } from '../models/core-response';
import { Datasource } from '../models/datasource';
import { map, tap } from 'rxjs/operators';
import { DatasourceMappingService } from './datasource-mapping.service';
import { HelperService } from './helper.service';

@Injectable()
export class DatasourceService {
    private baseUrl = environment.apiEndpoint + '/datasource';
    private datasources$: Observable<Datasource[]>;

    constructor(private http: HttpClient, private datasourceMappingService: DatasourceMappingService, private helperService: HelperService) {
        this.datasources$ = null;
    }

    resetCache() {
        this.datasources$ = null;
    }

    getAllDatasources(): Observable<Datasource[]> {
        return this.helperService.getCached(this.datasources$, this.http.get<Datasource[]>(this.baseUrl));
    }

    getDataSourceMappingId(dataSourceId: number, mappingName: string): Observable<number> {
        return this.datasourceMappingService.getAllDatasourceMappings().pipe(map(mappings => mappings.find(x => x.datasourceId === dataSourceId && x.name === mappingName).id));
    }

    getDefaultDataSourceMappingId(dataSourceId: number): Observable<number> {
        return this.datasourceMappingService.getAllDatasourceMappings().pipe(map(mappings => mappings.find(x => x.datasourceId === dataSourceId && x.name === '').id));
    }

    getDataSourceByName(dataSourceName: string): Observable<number> {
        return this.getAllDatasources().pipe(map(datasources => datasources.find(x => x.name === dataSourceName).id));
    }

    checkDataSourceDependants(datasourceId: number, periodId: number, seriesId: number): Observable<number> {
        return this.http.get<number>(`${this.baseUrl}/dependants/${datasourceId}/${periodId}/${seriesId}`);
    }

    insertDatasource(datasource: Datasource): Observable<Datasource> {
        return this.http.post<Datasource>(this.baseUrl, datasource).pipe(tap(this.resetCache), tap(this.datasourceMappingService.resetCache));
    }

    updateDatasource(datasource: Datasource): Observable<number> {
        return this.http.put<number>(this.baseUrl, datasource).pipe(tap(this.resetCache));
    }

    deleteDatasource(id: number): Observable<CoreResponse<number>> {
        return this.http.delete<CoreResponse<number>>(this.baseUrl + '/' + id).pipe(tap(this.resetCache), tap(this.datasourceMappingService.resetCache));
    }

    checkDeleteDatasource(id: number): Observable<string[]> {
        return this.http.get<string[]>(this.baseUrl + '/' + id + '/rule-dependents');
    }
}
